import { PubSkeletonGrayBox } from "../../../../style/skeleton";
import {
  PremiumPubBannerInfoWrapper,
  PremiumPubBannerInfoHeader,
  PremiumPubBannerPubInfo,
  PremiumPubBannerInfoBottom,
  PremiumPubBannerInfoIconWrapper,
} from "../../style";

const PremiumPubBannerInfoSkeleton = () => {
  return (
    <PremiumPubBannerInfoWrapper>
      <PremiumPubBannerInfoHeader>
        <PremiumPubBannerPubInfo>
          <PubSkeletonGrayBox height="22px" width="120px" />
          <PubSkeletonGrayBox height="16px" width="180px" />
          <PubSkeletonGrayBox height="16px" width="100px" />
        </PremiumPubBannerPubInfo>
        <PubSkeletonGrayBox height="22px" width="82px" />
      </PremiumPubBannerInfoHeader>
      <PremiumPubBannerInfoBottom>
        <PremiumPubBannerInfoIconWrapper>
          <PubSkeletonGrayBox height="17px" width="43px" />
          <PubSkeletonGrayBox height="17px" width="56px" />
        </PremiumPubBannerInfoIconWrapper>
        <PubSkeletonGrayBox height="20px" width="50px" />
      </PremiumPubBannerInfoBottom>
    </PremiumPubBannerInfoWrapper>
  );
};

export default PremiumPubBannerInfoSkeleton;
